"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const icons_1 = require("../../../icons");
const editor_1 = require("../../../utils/editor");
const editor_2 = require("../../constants/editor");
const button_1 = __importDefault(require("./button"));
const controlPanel_style_1 = __importDefault(require("./controlPanel.style"));
const ControlPanel = ({ classes, editorState, onToggleBlockType, onToggleInlineType, promptForLink, removeLink, disabled, isLinkButtonActive }) => {
    const rootProps = {
        className: classes.root,
        'data-is-disabled': disabled
    };
    return (jsx_runtime_1.jsxs("div", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx(button_1.default, { onClick: onToggleBlockType, active: editor_1.hasBlockType(editorState, editor_2.HEADER_ONE), buttonType: editor_2.HEADER_ONE, disabled: disabled }, void 0),
            jsx_runtime_1.jsx(button_1.default, { onClick: onToggleInlineType, active: editor_1.hasInlineStyle(editorState, editor_2.BOLD), buttonType: editor_2.BOLD, disabled: disabled }, void 0),
            jsx_runtime_1.jsx(button_1.default, { icon: jsx_runtime_1.jsx(icons_1.icons.Link, {}, void 0), promptForLink: promptForLink, removeLink: removeLink, active: editor_1.hasLink(editorState) || isLinkButtonActive, buttonType: editor_2.LINK, disabled: disabled }, void 0),
            jsx_runtime_1.jsx(button_1.default, { icon: jsx_runtime_1.jsx(icons_1.icons.Bullets, {}, void 0), onClick: onToggleBlockType, active: editor_1.hasBlockType(editorState, editor_2.UNORDERED_LIST_ITEM), buttonType: editor_2.UNORDERED_LIST_ITEM, disabled: disabled }, void 0)] }), void 0));
};
exports.ControlPanel = ControlPanel;
exports.ControlPanel.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    editorState: prop_types_1.default.object.isRequired,
    onToggleBlockType: prop_types_1.default.func,
    onToggleInlineType: prop_types_1.default.func,
    promptForLink: prop_types_1.default.func,
    removeLink: prop_types_1.default.func,
    disabled: prop_types_1.default.bool,
    isLinkButtonActive: prop_types_1.default.bool
};
exports.ControlPanel.defaultProps = {
    onToggleBlockType: () => { },
    onToggleInlineType: () => { },
    promptForLink: () => { },
    removeLink: () => { },
    disabled: false,
    isLinkButtonActive: false
};
exports.default = react_jss_1.default(controlPanel_style_1.default)(exports.ControlPanel);
//# sourceMappingURL=index.js.map